import React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import EasterEgg from '../sections/EasterEgg/EasterEgg';
import BriefModal from '../common/BriefModal/BriefModal';

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <Header />
      <main>{children}</main>
      <Footer />
      <EasterEgg />
      <BriefModal />
    </div>
  );
};

export default Layout;